import React, { useEffect, useMemo, useState, useContext } from 'react';
import { AuthContext } from "../../context/Auth/AuthContext";
import { 
  Paper, 
  Box, 
  Button, 
  TextField, 
  Popover, 
  MenuItem, 
  Menu, 
  IconButton, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Typography,
  makeStyles,
  Grid,
  Card,
  CardContent,
  CardActions,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  InputLabel,
  Select
} from '@material-ui/core';
import {
  Add as AddIcon,
  Folder as FolderIcon,
  MoreVert as MoreVertIcon,
  DeleteOutline as DeleteOutlineIcon,
  Edit as EditIcon,
  Build as BuildIcon,
  FolderOpen as MoveToFolderIcon,
  BorderColor as RenameIcon
} from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import ConfirmationModal from "../../components/ConfirmationModal";
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { TwitterPicker } from 'react-color';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(2),
  },
  stepContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  stepBox: {
    flex: 1,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    textAlign: 'center',
    fontWeight: 600,
  },
  stepBoxInactive: {
    flex: 1,
    backgroundColor: theme.palette.primary.light,
    color: '#fff',
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    textAlign: 'center',
    fontWeight: 600,
  },
  headerBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  headerButtons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  createFolderButton: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  createFlowButton: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  popoverContent: {
    padding: theme.spacing(2),
    width: 300,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  folderGrid: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
  },
  folderPaper: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    border: '1px solid',
    minWidth: 150,
  },
  folderName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  flowNameBox: {
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius,
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 150,
    maxWidth: 250,
  },
}));

export default function BulkMessages() {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);
  
  const [folders, setFolders] = useState([]);
  const [flows, setFlows] = useState([]);
  const [whatsapps, setWhatsapps] = useState([]);
  const [selectedFilterWhatsapp, setSelectedFilterWhatsapp] = useState('');
  
  const [search, setSearch] = useState('');
  const [activeFolder, setActiveFolder] = useState('Todos');
  const [showAllFolders, setShowAllFolders] = useState(true);
  
  const [anchorCreate, setAnchorCreate] = useState(null);
  const [openCreate, setOpenCreate] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [newFolderColor, setNewFolderColor] = useState('#1565c0');
  const [createError, setCreateError] = useState('');

  const getFolderColor = (folderName) => {
    const f = folders.find(ff => ff.name === folderName);
    return f?.color || '#1565c0';
  };

  const handleOpenCreate = (e) => {
    setAnchorCreate(e.currentTarget);
    setOpenCreate(true);
    setCreateError('');
  };

  const handleCloseCreate = () => {
    setOpenCreate(false);
    setAnchorCreate(null);
    setNewFolderName('');
    setNewFolderColor('#1565c0');
    setCreateError('');
  };

  const handleSubmitCreate = async () => {
    const name = (newFolderName || '').trim();
    if (!name) {
      setCreateError('Ingresa un nombre');
      return;
    }
    const exists = folders.some(f => (f.name || '').toLowerCase() === name.toLowerCase());
    if (exists) {
      setCreateError('Ya existe una carpeta con ese nombre');
      return;
    }
    try {
      await api.post('/bulk-folders', { name, color: newFolderColor });
      await reloadFolders();
      handleCloseCreate();
      toast.success('Carpeta creada con éxito');
    } catch (e) {
      setCreateError(e?.response?.data?.error || 'Error al crear carpeta');
      toast.error(e?.response?.data?.error || 'Error al crear carpeta');
    }
  };

  const [anchorCreateFlow, setAnchorCreateFlow] = useState(null);
  const [openCreateFlow, setOpenCreateFlow] = useState(false);
  const [newFlowName, setNewFlowName] = useState('');
  const [selectedFolder, setSelectedFolder] = useState('');
  const [flowError, setFlowError] = useState('');

  const handleOpenCreateFlow = (e) => {
    setAnchorCreateFlow(e.currentTarget);
    setOpenCreateFlow(true);
    setFlowError('');
    setSelectedFolder(activeFolder !== 'Todos' ? activeFolder : '');
  };

  const handleCloseCreateFlow = () => {
    setOpenCreateFlow(false);
    setAnchorCreateFlow(null);
    setNewFlowName('');
    setSelectedFolder('');
    setFlowError('');
  };

  const handleSubmitCreateFlow = async () => {
    const name = (newFlowName || '').trim();
    if (!name) { setFlowError('Ingresa un nombre'); return; }
    const folder = (selectedFolder || '').trim();
    if (!folder) { setFlowError('Selecciona una carpeta'); return; }
    
    // Note: The original code checked for duplicate names in the frontend, but the backend should handle uniqueness constraints or we can check here.
    const exists = flows.some(f => (f.folder_name || '') === folder && (f.name || '').toLowerCase() === name.toLowerCase());
    if (exists) { setFlowError('Ya existe un flujo con ese nombre en la carpeta'); return; }

    try {
      const folderObj = folders.find(f => f.name === folder);
      const folderId = folderObj?.id || null;
      const { data } = await api.post('/bulk-flows', { name, folderId });
      setFlows(prev => [data, ...prev]);
      handleCloseCreateFlow();
      toast.success('Flujo creado con éxito');
    } catch (e) {
      setFlowError(e?.response?.data?.error || 'Error al crear flujo');
      toast.error(e?.response?.data?.error || 'Error al crear flujo');
    }
  };

  const computedFolders = useMemo(() => {
    let resultFolders = folders;
    if (user?.profile === "admin" && selectedFilterWhatsapp) {
      resultFolders = resultFolders.filter(f => Number(f.whatsappId) === Number(selectedFilterWhatsapp));
    }
    
    return resultFolders.map(f => ({
      ...f,
      count: flows.filter(fl => {
        const folderName = fl.folder?.name || fl.BulkFlowFolder?.name || '';
        return folderName === f.name;
      }).length
    }));
  }, [folders, flows, selectedFilterWhatsapp, user]);

  const [folderMenuAnchor, setFolderMenuAnchor] = useState(null);
  const [folderMenuTarget, setFolderMenuTarget] = useState(null);
  const openFolderMenu = Boolean(folderMenuAnchor);
  
  const handleOpenFolderMenu = (event, folderName) => {
    event.stopPropagation();
    setFolderMenuAnchor(event.currentTarget);
    setFolderMenuTarget(folderName);
  };

  const handleCloseFolderMenu = () => {
    setFolderMenuAnchor(null);
  };

  const [renameDialogOpen, setRenameDialogOpen] = useState(false);
  const [renameValue, setRenameValue] = useState('');
  const [renameError, setRenameError] = useState('');

  const startRenameFolder = () => {
    setRenameValue(folderMenuTarget || '');
    setRenameError('');
    setRenameDialogOpen(true);
    handleCloseFolderMenu();
  };

  const closeRenameDialog = () => {
    setRenameDialogOpen(false);
    setRenameValue('');
    setRenameError('');
    setFolderMenuTarget(null);
  };

  const confirmRenameFolder = async () => {
    const newName = (renameValue || '').trim();
    if (!newName) { setRenameError('Ingresa un nombre'); return; }
    const exists = computedFolders.some(f => f.name.toLowerCase() === newName.toLowerCase());
    if (exists && newName !== folderMenuTarget) { setRenameError('Ya existe una carpeta con ese nombre'); return; }
    
    try {
      const target = folders.find(f => f.name === folderMenuTarget);
      if (!target) { setRenameError('Carpeta no encontrada'); return; }
      await api.put(`/bulk-folders/${target.id}`, { name: newName });
      await reloadFolders();
      await reloadFlows();
      if (activeFolder === folderMenuTarget) setActiveFolder(newName);
      closeRenameDialog();
      toast.success('Carpeta renombrada');
    } catch (e) {
      setRenameError(e?.response?.data?.error || 'Error al renombrar carpeta');
    }
  };

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  
  const startDeleteFolder = () => {
    setDeleteDialogOpen(true);
    handleCloseFolderMenu();
  };

  const closeDeleteDialog = () => { setDeleteDialogOpen(false); setFolderMenuTarget(null); };

  const confirmDeleteFolder = async () => {
    try {
      const target = folders.find(f => f.name === folderMenuTarget);
      if (!target) { closeDeleteDialog(); return; }
      await api.delete(`/bulk-folders/${target.id}`);
      await reloadFolders();
      await reloadFlows();
      if (activeFolder === target.name) setActiveFolder('Todos');
      closeDeleteDialog();
      toast.success('Carpeta eliminada con éxito');
    } catch (e) {
      toast.error(e?.response?.data?.error || 'Error al eliminar carpeta');
    }
  };

  const reloadFolders = async () => {
    try {
      const { data } = await api.get('/bulk-folders');
      setFolders(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
    }
  };

  const reloadFlows = async () => {
    try {
      const { data } = await api.get('/bulk-flows');
      setFlows(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchWhatsapps = async () => {
    try {
      const { data } = await api.get('/whatsapp');
      setWhatsapps(data);
    } catch (err) {
      console.error(err);
    }
  };

  const [renameFlowModalOpen, setRenameFlowModalOpen] = useState(false);
  const [selectedFlowToRename, setSelectedFlowToRename] = useState(null);
  const [newNameForFlow, setNewNameForFlow] = useState('');
  const [selectedFlowFolderId, setSelectedFlowFolderId] = useState('');

  const [moveFlowModalOpen, setMoveFlowModalOpen] = useState(false);
  const [selectedFlowToMove, setSelectedFlowToMove] = useState(null);
  const [targetFolderId, setTargetFolderId] = useState('');

  const handleOpenRenameFlow = (flow) => {
    setSelectedFlowToRename(flow);
    setNewNameForFlow(flow.name);
    setSelectedFlowFolderId(flow.folderId || '');
    setRenameFlowModalOpen(true);
  };

  const handleCloseRenameFlow = () => {
    setRenameFlowModalOpen(false);
    setSelectedFlowToRename(null);
    setNewNameForFlow('');
    setSelectedFlowFolderId('');
  };

  const handleSaveRenameFlow = async () => {
    if (!newNameForFlow.trim()) return;
    try {
      await api.put(`/bulk-flows/${selectedFlowToRename.id}`, { 
        name: newNameForFlow, 
        folderId: selectedFlowFolderId 
      });
      toast.success('Flujo actualizado con éxito');
      reloadFlows();
      handleCloseRenameFlow();
    } catch (e) {
      toast.error('Error al actualizar flujo');
    }
  };

  const handleOpenMoveFlow = (flow) => {
    setSelectedFlowToMove(flow);
    setTargetFolderId(flow.folderId || '');
    setMoveFlowModalOpen(true);
  };

  const handleCloseMoveFlow = () => {
    setMoveFlowModalOpen(false);
    setSelectedFlowToMove(null);
    setTargetFolderId('');
  };

  const handleSaveMoveFlow = async () => {
    if (!targetFolderId) return;
    try {
      await api.put(`/bulk-flows/${selectedFlowToMove.id}`, { folderId: targetFolderId });
      toast.success('Flujo movido');
      reloadFlows();
      handleCloseMoveFlow();
    } catch (e) {
      toast.error('Error al mover flujo');
    }
  };

  const [deleteFlowId, setDeleteFlowId] = useState(null);
  const [deleteFlowModalOpen, setDeleteFlowModalOpen] = useState(false);

  const handleOpenDeleteFlow = (flow) => {
    setDeleteFlowId(flow.id);
    setDeleteFlowModalOpen(true);
  };

  const handleCloseDeleteFlow = () => {
    setDeleteFlowId(null);
    setDeleteFlowModalOpen(false);
  };

  const handleConfirmDeleteFlow = async () => {
    try {
      await api.delete(`/bulk-flows/${deleteFlowId}`);
      toast.success('Flujo eliminado con éxito');
      reloadFlows();
    } catch (err) {
      toast.error('Error al eliminar flujo');
    }
    handleCloseDeleteFlow();
  };

  const filteredFlows = useMemo(() => {
    let result = flows;
    if (user?.profile === "admin" && selectedFilterWhatsapp) {
      result = result.filter(fl => Number(fl.whatsappId) === Number(selectedFilterWhatsapp));
    }
    if (activeFolder !== 'Todos') {
      result = result.filter(fl => {
        const folderName = fl.folder?.name || fl.BulkFlowFolder?.name || '';
        return folderName === activeFolder;
      });
    }
    if (search) {
      result = result.filter(f => f.name.toLowerCase().includes(search.toLowerCase()));
    }
    return result;
  }, [flows, activeFolder, search, selectedFilterWhatsapp, user]);

  useEffect(() => { reloadFolders(); reloadFlows(); fetchWhatsapps(); }, []);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <ConfirmationModal
          title="Eliminar Flujo"
          open={deleteFlowModalOpen}
          onClose={handleCloseDeleteFlow}
          onConfirm={handleConfirmDeleteFlow}
        >
          ¿Estás seguro de que deseas eliminar este flujo? Esta acción no se puede deshacer.
        </ConfirmationModal>

        <div className={classes.stepContainer}>
          <div className={classes.stepBox}>
            Paso 1 Creación de flujos
          </div>
          <div className={classes.stepBoxInactive}>
            Paso 2 Programación de flujos
          </div>
        </div>

        <div className={classes.headerBar}>
          <Typography variant="h6">Flujos de conversación</Typography>
          <div className={classes.headerButtons}>
            {user?.profile === "admin" && (
              <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
                <InputLabel style={{ backgroundColor: 'transparent', padding: '0 4px' }}>Filtrar Conexión</InputLabel>
                <Select
                  value={selectedFilterWhatsapp}
                  onChange={(e) => setSelectedFilterWhatsapp(e.target.value)}
                  label="Filtrar Conexión"
                >
                  <MenuItem value=""><em>Todas</em></MenuItem>
                  {whatsapps.map((w) => (
                    <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            <Button 
              variant="contained" 
              className={classes.createFolderButton} 
              endIcon={<AddIcon />} 
              onClick={handleOpenCreate}
            >
              CREAR CARPETA
            </Button>
            <Button 
              variant="contained" 
              className={classes.createFlowButton}
              endIcon={<AddIcon />} 
              onClick={handleOpenCreateFlow} 
              disabled={!computedFolders.length}
            >
              CREAR FLUJO
            </Button>
            <TextField size="small" placeholder="Buscar" value={search} onChange={(e)=>setSearch(e.target.value)} variant="outlined" />
          </div>
        </div>

        <Popover
          open={openCreate}
          anchorEl={anchorCreate}
          onClose={handleCloseCreate}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <div className={classes.popoverContent}>
            <TextField
              autoFocus
              fullWidth
              variant="outlined"
              placeholder="Nombre"
              value={newFolderName}
              onChange={(e)=>setNewFolderName(e.target.value)}
              error={!!createError}
              helperText={createError || ' '}
              onKeyDown={(e)=>{ if(e.key==='Enter'){ e.preventDefault(); handleSubmitCreate(); } }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Typography variant="body2">Color</Typography>
              <TwitterPicker 
                triangle="hide"
                width="100%"
                color={newFolderColor}
                onChangeComplete={(c)=>setNewFolderColor(c.hex)}
              />
            </div>
            <Button fullWidth variant="contained" className={classes.createFlowButton} onClick={handleSubmitCreate}>CREAR CARPETA</Button>
          </div>
        </Popover>

        <Popover
          open={openCreateFlow}
          anchorEl={anchorCreateFlow}
          onClose={handleCloseCreateFlow}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <div className={classes.popoverContent}>
            <TextField
              autoFocus
              fullWidth
              variant="outlined"
              placeholder="Nombre"
              value={newFlowName}
              onChange={(e)=>setNewFlowName(e.target.value)}
            />
            <TextField
              select
              label="Carpeta"
              value={selectedFolder}
              onChange={(e)=>setSelectedFolder(e.target.value)}
              fullWidth
              variant="outlined"
            >
              {computedFolders.map(f => (
                <MenuItem key={f.name} value={f.name}>{f.name}</MenuItem>
              ))}
            </TextField>
            {flowError && (<Typography color="error" variant="caption">{flowError}</Typography>)}
            <Button fullWidth variant="contained" className={classes.createFlowButton} onClick={handleSubmitCreateFlow}>CREAR FLUJO</Button>
          </div>
        </Popover>

        <div className={classes.folderGrid}>
          <div 
            className={classes.folderPaper} 
            onClick={()=>setActiveFolder('Todos')}
            style={{ 
              borderColor: activeFolder==='Todos' ? '#2196f3' : '#e0e0e0',
              backgroundColor: activeFolder==='Todos' ? '#2196f3' : '#fff'
            }}
          >
            <FolderIcon style={{ color: activeFolder==='Todos' ? '#fff' : '#e0e0e0' }} />
            <Typography style={{ fontWeight: 600, flex: 1, color: activeFolder==='Todos' ? '#fff' : '#1a1a2e' }}>Todos los flujos</Typography>
            <Typography variant="body2" style={{ color: activeFolder==='Todos' ? '#fff' : '#757575' }}>{flows.length}</Typography>
          </div>

          {(showAllFolders ? computedFolders : computedFolders.slice(0, 10)).map((f) => (
            <div 
              key={f.name} 
              className={classes.folderPaper}
              onClick={()=>setActiveFolder(f.name)}
              style={{ 
                borderColor: activeFolder===f.name ? getFolderColor(f.name) : '#e0e0e0',
                backgroundColor: activeFolder===f.name ? getFolderColor(f.name) : '#fff'
              }}
            >
              <FolderIcon style={{ color: activeFolder===f.name ? '#fff' : getFolderColor(f.name) }} />
              <Typography className={classes.folderName} style={{ flex: 1, color: activeFolder===f.name ? '#fff' : '#1a1a2e' }}>{f.name}</Typography>
              <Typography variant="body2" style={{ color: activeFolder===f.name ? '#fff' : '#757575' }}>{f.count}</Typography>
              <IconButton size="small" onClick={(e)=>handleOpenFolderMenu(e, f.name)} style={{ padding: 4 }}>
                <MoreVertIcon fontSize="small" style={{ color: activeFolder===f.name ? '#fff' : 'grey' }} />
              </IconButton>
            </div>
          ))}

          {computedFolders.length > 10 && (
            <div className={classes.folderPaper} style={{ justifyContent: 'center', minWidth: 'auto' }}>
              <Button onClick={()=>setShowAllFolders(v=>!v)}>{showAllFolders ? 'Menos' : 'Más'}</Button>
            </div>
          )}
        </div>

        <Box mt={4}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: 'bold' }}>NOMBRE</TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>CONEXIONES</TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>ÚLTIMO CAMBIO</TableCell>
                  <TableCell style={{ fontWeight: 'bold' }} align="right">ACCIONES</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredFlows.map(flow => (
                  <TableRow key={flow.id} hover>
                    <TableCell>
                      <div className={classes.flowNameBox} style={{ backgroundColor: getFolderColor(flow.folder?.name || flow.BulkFlowFolder?.name) }}>
                        <Typography variant="body1" style={{ fontWeight: 600 }}>
                          {flow.name}
                        </Typography>
                        <Typography variant="caption" style={{ opacity: 0.9 }}>
                          {flow.folder?.name || flow.BulkFlowFolder?.name || 'Sin carpeta'}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      {/* Placeholder for connections data */}
                      <Typography variant="body2" color="textSecondary">
                        {flow.connections ? 'Configurado' : 'Sin pasos'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {flow.updatedAt && format(parseISO(flow.updatedAt), "dd/MM/yyyy HH:mm", { locale: es })}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton size="small" onClick={() => history.push(`/bulk-messages/${flow.id}`)}>
                        <EditIcon fontSize="small" color="primary" />
                      </IconButton>
                      <IconButton size="small" onClick={() => handleOpenRenameFlow(flow)}>
                        <RenameIcon fontSize="small" style={{ color: '#00bcd4' }} />
                      </IconButton>
                      <IconButton size="small" onClick={() => handleOpenMoveFlow(flow)}>
                        <MoveToFolderIcon fontSize="small" style={{ color: '#ff9800' }} />
                      </IconButton>
                      <IconButton size="small" onClick={() => handleOpenDeleteFlow(flow)}>
                        <DeleteOutlineIcon fontSize="small" color="error" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {filteredFlows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <Typography color="textSecondary">
                        No hay flujos en esta carpeta.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {computedFolders.length === 0 && (
          <Box mt={1}>
            <Typography variant="body2" color="textSecondary">Crea una carpeta para comenzar y luego añade flujos dentro.</Typography>
          </Box>
        )}

        <Menu
          open={openFolderMenu}
          anchorEl={folderMenuAnchor}
          onClose={handleCloseFolderMenu}
        >
          <MenuItem onClick={startRenameFolder}>Renombrar</MenuItem>
          <MenuItem onClick={startDeleteFolder}>Eliminar</MenuItem>
        </Menu>

        <Dialog open={renameDialogOpen} onClose={closeRenameDialog}>
          <DialogTitle>Renombrar carpeta</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              fullWidth
              value={renameValue}
              onChange={(e)=>setRenameValue(e.target.value)}
              error={!!renameError}
              helperText={renameError || ' '}
              placeholder="Nuevo nombre"
              onKeyDown={(e)=>{ if(e.key==='Enter'){ e.preventDefault(); confirmRenameFolder(); } }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeRenameDialog}>Cancelar</Button>
            <Button variant="contained" color="primary" onClick={confirmRenameFolder}>Guardar</Button>
          </DialogActions>
        </Dialog>

        <ConfirmationModal
          title="Eliminar carpeta"
          open={deleteDialogOpen}
          onClose={closeDeleteDialog}
          onConfirm={confirmDeleteFolder}
        >
          ¿Deseas eliminar la carpeta "{folderMenuTarget}"? Los flujos quedarán sin carpeta.
        </ConfirmationModal>

        <Dialog open={renameFlowModalOpen} onClose={handleCloseRenameFlow}>
          <DialogTitle>Editar flujo</DialogTitle>
          <DialogContent style={{ minWidth: 300 }}>
            <TextField
              autoFocus
              fullWidth
              label="Nombre"
              value={newNameForFlow}
              onChange={(e) => setNewNameForFlow(e.target.value)}
              margin="dense"
              variant="outlined"
            />
            <TextField
              select
              label="Carpeta"
              value={selectedFlowFolderId}
              onChange={(e) => setSelectedFlowFolderId(e.target.value)}
              fullWidth
              variant="outlined"
              margin="dense"
            >
              {folders.map(f => (
                <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>
              ))}
            </TextField>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseRenameFlow} color="default">CANCELAR</Button>
            <Button variant="contained" color="primary" onClick={handleSaveRenameFlow}>GUARDAR</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={moveFlowModalOpen} onClose={handleCloseMoveFlow}>
          <DialogTitle>Mover Flujo a Carpeta</DialogTitle>
          <DialogContent style={{ minWidth: 300 }}>
            <TextField
              select
              label="Carpeta destino"
              value={targetFolderId}
              onChange={(e) => setTargetFolderId(e.target.value)}
              fullWidth
              variant="outlined"
              margin="dense"
            >
              {folders.map(f => (
                <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>
              ))}
            </TextField>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseMoveFlow}>Cancelar</Button>
            <Button variant="contained" color="primary" onClick={handleSaveMoveFlow}>Mover</Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </div>
  );
}
